import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private urlAPI = environment.API;
  private feedUpdateToday = 'getFeedUpdate';
  private feedUpdateTodayCarrousel = 'getFeedUpdateCarrousel';
  private newsFeed = 'getNewsMatch';

  constructor(
    private http: HttpClient,
    private translateService: TranslationService ) {}

  /***
   * Get all news feed today
   */
  getFeedUpdates(): Observable<any> {
    let date: any = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    date = `${year}${month}${day}`;

    const time: any = '000000';
    return this.http.get<any>(
      `${this.urlAPI}${this.feedUpdateToday}/${date}/${time}`
    );
  }

  /***
   * Get all news feed today
   */
  getFeedUpdatesCarrousel(): Observable<any> {
    let date: any = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    date = `${year}${month}${day}`;

    const time: any = '000000';
    return this.http.get<any>(
      `${this.urlAPI}${this.feedUpdateTodayCarrousel}/${date}/${time}`
    );
  }

  /***
   * Get news feed by channel
   */
  getNewsFeed(channel: string): Observable<any> {
    return this.http.post<any>(`${this.urlAPI}${this.newsFeed}`, {
      channel,
      lng: this.translateService.getCurrentLanguage(),
    });
  }
}
